import { startDesignDnaProceedDemoStreamLoop } from './designDnaProceedDemoStreamLoop.js'

/** @param {import('./runDesignDnaDemoStream.js').DesignDnaStreamCtx} ctx */
export function runDesignDnaProceedDemoStream(ctx) {
  startDesignDnaProceedDemoStreamLoop(ctx)
}
